/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Space_Profile_Map_LocatingInputs */

const en_admin_space_profile_map_locating = /** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're locating your space on the map…`)
};

const de_admin_space_profile_map_locating = /** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir suchen deinen Space auf der Karte…`)
};

const es_admin_space_profile_map_locating = /** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos localizando tu espacio en el mapa…`)
};

const fr_admin_space_profile_map_locating = /** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous localisons votre espace sur la carte…`)
};

const nl_admin_space_profile_map_locating = /** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We lokaliseren je Space op de kaart…`)
};

/** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */
const it_admin_space_profile_map_locating = en_admin_space_profile_map_locating;

/** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */
const pt_br2_admin_space_profile_map_locating = en_admin_space_profile_map_locating;

/** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */
const pl_admin_space_profile_map_locating = en_admin_space_profile_map_locating;

/** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */
const hu_admin_space_profile_map_locating = en_admin_space_profile_map_locating;

/** @type {(inputs: Admin_Space_Profile_Map_LocatingInputs) => LocalizedString} */
const ro_admin_space_profile_map_locating = en_admin_space_profile_map_locating;

/**
* | output |
* | --- |
* | "We're locating your space on the map…" |
*
* @param {Admin_Space_Profile_Map_LocatingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_space_profile_map_locating = /** @type {((inputs?: Admin_Space_Profile_Map_LocatingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Space_Profile_Map_LocatingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_space_profile_map_locating(inputs)
	if (locale === "de") return de_admin_space_profile_map_locating(inputs)
	if (locale === "es") return es_admin_space_profile_map_locating(inputs)
	if (locale === "fr") return fr_admin_space_profile_map_locating(inputs)
	if (locale === "nl") return nl_admin_space_profile_map_locating(inputs)
	if (locale === "it") return it_admin_space_profile_map_locating(inputs)
	if (locale === "pt-BR") return pt_br2_admin_space_profile_map_locating(inputs)
	if (locale === "pl") return pl_admin_space_profile_map_locating(inputs)
	if (locale === "hu") return hu_admin_space_profile_map_locating(inputs)
	return ro_admin_space_profile_map_locating(inputs)
});
export { admin_space_profile_map_locating as "admin.space_profile_map.locating" }